<template>
  <div class="loader-wrapper">
      <div class="loader"></div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.loader-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    .loader {
      border: 13px solid #f3f3f3; /* Light grey */
      border-top: 13px solid #3498db; /* Blue */
      border-radius: 50%;
      width: 100px;
      height: 100px;
      animation: spin 1s linear infinite;
    }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

</style>